// The shared parts of the staff screens' design: the top bar, the side panel
// every row opens into, the theme. Native review pending (az, ru).
import type { Phrase } from '../staffText'

export const ui = {
  'ui.mainMenu': { en: 'Main menu', az: 'Əsas menyu', ru: 'Главное меню' },
  'ui.home': { en: 'Home', az: '', ru: '' },
  'ui.railCollapse': { en: 'Collapse menu', az: '', ru: '' },
  'ui.railExpand': { en: 'Expand menu', az: '', ru: '' },
  'ui.close': { en: 'Close', az: 'Bağla', ru: 'Закрыть' },
  'ui.discardAsk': { en: 'Discard your changes?', az: 'Dəyişikliklər silinsin?', ru: 'Отменить изменения?' },
  'ui.keepEditing': { en: 'Keep editing', az: 'Davam et', ru: 'Вернуться к правке' },
  'ui.discard': { en: 'Discard', az: 'Sil', ru: 'Сбросить' },
  'ui.unsaved': { en: 'Unsaved changes', az: 'Saxlanmamış dəyişikliklər', ru: 'Несохранённые изменения' },
  'ui.themeDark': { en: 'Dark theme', az: 'Qaranlıq tema', ru: 'Тёмная тема' },
  'ui.themeLight': { en: 'Light theme', az: 'İşıqlı tema', ru: 'Светлая тема' },
  'ui.accountMenu': { en: 'Account and sign out', az: 'Hesab və çıxış', ru: 'Учётная запись и выход' },
  'ui.search': { en: 'Search', az: 'Axtar', ru: 'Поиск' },
  'ui.home.waiting': { en: '{n} waiting', az: '{n} gözləyir', ru: 'ожидают: {n}' },
  'ui.home.longest': { en: 'longest {time}', az: 'ən uzun: {time}', ru: 'дольше всех: {time}' },
  'ui.home.queuesOver': { en: '{n, plural, one {# queue} other {# queues}} over target', az: 'hədəfi keçən növbə: {n}', ru: 'очередей сверх нормы: {n}' },
  'ui.home.requests': { en: '{n, plural, one {# request} other {# requests}}', az: '{n} sorğu', ru: 'запросов: {n}' },
  'ui.home.nothing': { en: 'Nothing to open', az: 'Açılacaq bölmə yoxdur', ru: 'Нет доступных разделов' },
  // Redesign 2026-10: English only; az/ru left empty fall back to English.
  'ui.allModules': { en: 'All modules', az: '', ru: '' },
  'ui.product': { en: 'Queue', az: '', ru: '' },
  'ui.select': { en: 'Select', az: '', ru: '' },
  'ui.noMatches': { en: 'No matches', az: '', ru: '' },
  'ui.removeItem': { en: 'Remove {name}', az: '', ru: '' },
  'ui.pager.showing': { en: 'Showing {from}–{to} of {n}', az: '', ru: '' },
  'ui.pager.rows': { en: 'Rows per page', az: '', ru: '' },
  'ui.pager.prev': { en: 'Previous page', az: '', ru: '' },
  'ui.pager.next': { en: 'Next page', az: '', ru: '' },
  'ui.pager.page': { en: 'Page {n} of {of}', az: '', ru: '' },
  'ui.pager.label': { en: 'Pagination', az: '', ru: '' },
} satisfies Record<string, Phrase>
